export enum ProductType {
  AirAmbulance = 'AirAmbulance',
  KidnapAndExtortion = 'KidnapAndExtortion',
  SecurityResponse = 'SecurityResponse',
  DutyOfCare = 'DutyOfCare',
}
